module.exports = __webpack_public_path__ + "static/img/2.da41d35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/cooperation/2.png
// module id = rBs2
// module chunks = 3